import React, { useEffect } from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typewriter from "typewriter-effect";
import { introdata, meta } from "../../content_option";
import { Link } from "react-router-dom";
import BackgroundVideo from "../../components/backgroundVideo";

import Process from "../../components/process";
import Footer from "../../components/footer";
import TestimonalComponent from "../../components/testimonal";
import { galleryData } from "../gallery/data";
import GridComponent from "../../components/grid";
import About2 from "../../components/aboutSection/about2";
import StaticAbout from "../../components/aboutSection/staticAbout";
import AOS from "aos";
import "aos/dist/aos.css";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { useDispatch, useSelector } from "react-redux";
import { allDocument } from "../../features/imageUpload/imageUpload.action";
import { Box, CircularProgress } from "@material-ui/core";
import {LoveStories} from "../../components/loveStories";
import { Memories } from "../../components/memories";
import { Moments } from "../../components/loveStories";
import vector from "../../assets/videos/vectorlogo.png"
export const Home = () => {
  const dispatch = useDispatch();
  const { allDoc, allDocLoading, allDocLoadingSucess } = useSelector(
    (state) => state.imageUpload
  );
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  useEffect(() => {
    dispatch(allDocument());
  }, [dispatch]);

  return (
    <HelmetProvider>
      <TransitionGroup>
        <CSSTransition classNames="fade-in" timeout={1000}>
          <section id="home" className="home">
            <BackgroundVideo />
            <Helmet>
              <meta charSet="utf-8" />
              <title> {meta.title}</title>
              <meta name="description" content={meta.description} />
            </Helmet>

            {/* <div className="BannerContainer">
            <h2 className="BannerText" data-aos="fade-up"  data-aos-delay="1000">Forever begins with us</h2>
            </div> */}
          </section>
        </CSSTransition>
      </TransitionGroup>
{/* 
      
      <div>
          <img
            src={vector} />



        </div>

      */}

      <LoveStories/>
      <Memories/>


      <Footer />
    </HelmetProvider>
  );
};
